import React, { useEffect, useRef, useState } from 'react'

//MUI IMPORTS
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '@mui/material/Switch';
import {
    Box,
    TextField,
    Autocomplete,
    Button,
    DialogActions,
    Grid,
    Typography,
    Paper,
    Fade,
    IconButton,
    Alert,
} from "@mui/material";
import { alpha, styled } from '@mui/material/styles';
import SearchIcon from "@mui/icons-material/Search"
import CloseIcon from "@mui/icons-material/Close"
import ShopIcon from '@mui/icons-material/Shop';

import { getData } from '../../../../services/library';

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    background: "linear-gradient(135deg, #164e63 0%, #0c3a47 100%)",
    color: "#ffffff",
    padding: "16px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    "& .MuiTypography-root": {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        fontSize: "1.25rem",
        fontWeight: 450,
    },
}))

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: "10px 14px",
    backgroundColor: "#f1f5f9",
    borderRadius: "12px",
    marginBottom: "24px",
    border: "1px solid #e2e8f0",
    transition: "all 0.3s ease",
    "&:hover": {
        boxShadow: "0 4px 12px rgba(22, 78, 99, 0.08)",
    },
}))

const DialogOCS = (props) => {
    const [ocs, setOcs] = useState(null)
    const [cargando, setCargando] = useState(false);
    const [selected, setSelected] = useState(props.ocsSelected || [])

    const handleSubmit = () => {
        props.setOcsSelected(selected)
        props.handleCloseAddOC()
    }

    useEffect(() => {
        getData("/ordencompra/xproveedor/" + props?.proveedor?.id, setOcs)
    }, [props.proveedor])

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.handleCloseAddOC}
                fullWidth
                maxWidth="sm"
                TransitionComponent={Fade}
                PaperProps={{
                    sx: {
                        borderRadius: "4px",
                        boxShadow: "0 20px 60px rgba(22, 78, 99, 0.15)",
                    },
                }}
            >
                <StyledDialogTitle>
                    <Typography component="div">
                        <SearchIcon sx={{ fontSize: "28px" }} />
                        Ordenes de compra {props.proveedor?.denominacion}
                    </Typography>
                    <IconButton
                        onClick={props.handleCloseAddOC}
                        sx={{
                            color: "#ffffff",
                            "&:hover": {
                                backgroundColor: alpha("#ffffff", 0.1),
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </StyledDialogTitle>

                <DialogContent sx={{ padding: "32px", backgroundColor: "#ffffff", mt: 3 }}>
                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                        {ocs?.length > 0 ? (
                            <Box sx={{ marginTop: "8px" }}>
                                <Autocomplete
                                    multiple
                                    autoFocus
                                    disableClearable
                                    placeholder="N° Orden Comrpa"
                                    options={ocs ?? []}
                                    loading={cargando}
                                    value={selected}
                                    onChange={(e, value) => {
                                        setSelected(value)
                                    }}
                                    renderOption={(props, option) => (
                                        <Box
                                            component="li"
                                            {...props}
                                            key={option.id}
                                            sx={{
                                                padding: "12px 16px !important",
                                                borderBottom: "1px solid #f1f5f9",
                                                transition: "all 0.2s ease",
                                                "&:hover": {
                                                    backgroundColor: "#f1f5f9 !important",
                                                },
                                                '&[aria-selected="true"]': {
                                                    backgroundColor: alpha("#164e63", 0.08) + " !important",
                                                    color: "#164e63",
                                                    fontWeight: 600,
                                                },
                                            }}
                                        >
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <ShopIcon sx={{ fontSize: "18px", color: "#475569" }} />
                                                <Typography>
                                                    Id: {option?.id} ({option?.estado})
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Orden de Compra "
                                            variant="outlined"
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: "12px",
                                                    backgroundColor: "#ffffff",
                                                    transition: "all 0.3s ease",
                                                    "&:hover": {
                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: "#164e63",
                                                        },
                                                    },
                                                    "&.Mui-focused": {
                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: "#164e63",
                                                            borderWidth: "2px",
                                                        },
                                                    },
                                                },
                                                "& .MuiInputLabel-root": {
                                                    color: "#475569",
                                                    fontWeight: 500,
                                                    "&.Mui-focused": {
                                                        color: "#164e63",
                                                    },
                                                },
                                            }}
                                            InputProps={{
                                                ...params.InputProps,
                                            }}
                                        />
                                    )}
                                    getOptionLabel={(option) =>
                                        option?.id
                                    }
                                    noOptionsText="No se encontraron coincidencias."
                                />
                            </Box>
                        ) : (
                            <Box sx={{ marginTop: "8px" }}>
                                <Alert severity="warning">
                                    No se encontraron ordenes de compra vinculadas a este proveedor.
                                </Alert>
                            </Box>
                        )}
                    </form>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px 32px 32px",
                        gap: "12px",
                        backgroundColor: "#ffffff",
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={!selected?.length}
                        sx={{
                            borderRadius: "10px",
                            padding: "10px 32px",
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "0.95rem",
                            backgroundColor: "#164e63",
                            boxShadow: "0 4px 12px rgba(22, 78, 99, 0.25)",
                            "&:hover": {
                                backgroundColor: "#0c3a47",
                                boxShadow: "0 6px 16px rgba(22, 78, 99, 0.35)",
                            },
                            "&:disabled": {
                                backgroundColor: "#cbd5e1",
                                color: "#94a3b8",
                            },
                        }}
                    >
                        Seleccionar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default DialogOCS